module.exports = __webpack_public_path__ + "static/media/xbox_logo_png.a1f47646.png";